import React from 'react';
import { Link } from 'react-router-dom';
import Message from '../../common/message/Message';

import {
	ERROR_GENERIC,
	ONBOARDING_ACCOUNT_DISABLED,
	ONBOARDING_ACCOUNT_DISABLED_FORGOT_PASSWORD,
	ONBOARDING_ACCOUNT_LOCKED,
	ONBOARDING_ACCOUNT_LOCKED_LINK,
	ONBOARDING_EXISTING_ACCOUNT,
	ONBOARDING_EXISTING_ACCOUNT_LINK,
	ONBOARDING_EMAIL_CHECK_UNKNOWN_ERROR,
	ONBOARDING_TOO_MANY_REQUESTS,
	ONBOARDING_UNKNOWN_EMAIL,
	ONBOARDING_UNKNOWN_EMAIL_LINK,
	ONBOARDING_VOUCHER_ACCEPTED,
	ONBOARDING_VOUCHER_EXPIRED,
	ONBOARDING_VOUCHER_INVALID,
	ONBOARDING_VOUCHER_ALREADY_USED,
	ONBOARDING_WRONG_PASSWORD,
	ONBOARDING_WRONG_PASSWORD_LINK,
	ONBOARDING_ACCOUNT_FORCED_PWD_RESET,
	ONBOARDING_ACCOUNT_FORCED_PWD_RESET_LINK,
} from '../../../constants/Copy';
import {
	ACCOUNT_DISABLED,
	ACCOUNT_LOCKED,
	ACCOUNT_FORCED_PWD_RESET,
	EMAIL_NOT_FOUND,
	ERROR,
	EXISTING_ACCOUNT,
	TOO_MANY_REQUESTS,
	VOUCHER_ACCEPTED,
	VOUCHER_INVALID,
	VOUCHER_ALREADY_USED,
	VOUCHER_EXPIRED,
	WRONG_PASSWORD,
	EMAIL_CHECK_UNKNOWN_ERROR,
} from '../../../constants/ErrorTypes';
import { ROUTE_FORGOT_PASSWORD, ROUTE_LOGIN, ROUTE_REGISTER } from '../../../constants/Routes';

const errorTypes = {
	[WRONG_PASSWORD]: {
		type: 'error',
		message: (
			<Message
				message={ONBOARDING_WRONG_PASSWORD}
				values={{ link: <Link to={ROUTE_FORGOT_PASSWORD}>{ONBOARDING_WRONG_PASSWORD_LINK}</Link> }}
			/>
		),
	},
	[EMAIL_NOT_FOUND]: {
		type: 'error',
		message: (
			<Message
				message={ONBOARDING_UNKNOWN_EMAIL}
				values={{
					link: <Link to={ROUTE_REGISTER}>{ONBOARDING_UNKNOWN_EMAIL_LINK}</Link>,
				}}
			/>
		),
	},
	[ACCOUNT_DISABLED]: {
		type: 'error',
		message: (
			<Message
				message={ONBOARDING_ACCOUNT_DISABLED}
				values={{
					forgot_password: (
						<Link to={ROUTE_FORGOT_PASSWORD}>{ONBOARDING_ACCOUNT_DISABLED_FORGOT_PASSWORD}</Link>
					),
				}}
			/>
		),
	},
	[ACCOUNT_LOCKED]: {
		type: 'error',
		message: (
			<Message
				message={ONBOARDING_ACCOUNT_LOCKED}
				values={{
					link: (
						<Link data-test="account-locked-link" to={ROUTE_FORGOT_PASSWORD}>
							{ONBOARDING_ACCOUNT_LOCKED_LINK}
						</Link>
					),
				}}
			/>
		),
	},
	[ACCOUNT_FORCED_PWD_RESET]: {
		type: 'error',
		message: (
			<Message
				message={ONBOARDING_ACCOUNT_FORCED_PWD_RESET}
				values={{
					link: (
						<Link data-test="account-pwdchange-link" to={ROUTE_FORGOT_PASSWORD}>
							{ONBOARDING_ACCOUNT_FORCED_PWD_RESET_LINK}
						</Link>
					),
				}}
			/>
		),
	},
	[EXISTING_ACCOUNT]: {
		type: 'error',
		message: (
			<Message
				message={ONBOARDING_EXISTING_ACCOUNT}
				values={{ link: <Link to={ROUTE_LOGIN}>{ONBOARDING_EXISTING_ACCOUNT_LINK}</Link> }}
			/>
		),
	},
	[TOO_MANY_REQUESTS]: {
		type: 'error',
		message: <Message message={ONBOARDING_TOO_MANY_REQUESTS} />,
	},
	[ERROR]: {
		type: 'error',
		message: <Message message={ERROR_GENERIC} />,
	},
	[EMAIL_CHECK_UNKNOWN_ERROR]: {
		type: 'error',
		message: <Message message={ONBOARDING_EMAIL_CHECK_UNKNOWN_ERROR} />,
	},
	[VOUCHER_ACCEPTED]: {
		type: 'notification',
		message: <Message message={ONBOARDING_VOUCHER_ACCEPTED} />,
	},
	[VOUCHER_INVALID]: {
		type: 'error',
		message: <Message message={ONBOARDING_VOUCHER_INVALID} />,
	},
	[VOUCHER_ALREADY_USED]: {
		type: 'error',
		message: <Message message={ONBOARDING_VOUCHER_ALREADY_USED} />,
	},
	[VOUCHER_EXPIRED]: {
		type: 'error',
		message: <Message message={ONBOARDING_VOUCHER_EXPIRED} />,
	},
};

export default errorTypes;
